import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class DeliveryContainer extends HTMLElement {
  connectedCallback() {
  document.addEventListener(
    ThemeEvents.variantUpdate,
    this.updateDeliveryContainer
  );
}

disconnectedCallback() {
  document.removeEventListener(
    ThemeEvents.variantUpdate,
    this.updateDeliveryContainer
  );
}

  /**
   * Updates the price of delivery.
   * Remember to add .js file to scripts.liquid
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDeliveryContainer = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDeliveryContainer = event.detail.data.html.querySelector('delivery-container');

    if (!newDeliveryContainer) return;

    morph(this, newDeliveryContainer, { childrenOnly: true });
  };
}

if (!customElements.get('delivery-container')) {
  customElements.define('delivery-container', DeliveryContainer);
}
